import { Header } from "../components";

const Dashboard = () => {
  return (
    <>
      <Header />
    </>
  );
};

export default Dashboard;
